import React, { useState } from 'react';
import ConsolidatedPropertyListModal from './ConsolidatedPropertyListModal';
import { type AdproductsZuoraBillingInvoiceDto } from '@zg-rentals/ts-adproducts-client';

const PropertyNameList = ({ invoice }: { invoice: AdproductsZuoraBillingInvoiceDto }) => {
  const [showPropertyListModal, setShowPropertyListModal] = useState<boolean>(false);
  const [propertyList, setShowPropertyList] = useState<Array<string>>([]);

  const handlePropertyListClick = (properties: Array<string>) => {
    setShowPropertyList(properties);
    setShowPropertyListModal(true);
  };

  if (invoice.propertyNames.length === 0) return null;
  if (invoice.propertyNames.length === 1) return <>{invoice.propertyNames}</>;
  return (
    <>
      <div onClick={() => handlePropertyListClick(invoice.propertyNames)}>
        {`${invoice.propertyNames.length} Properties`}
      </div>
      {showPropertyListModal && (
        <ConsolidatedPropertyListModal
          open={showPropertyListModal}
          propertyList={propertyList}
          onClose={() => setShowPropertyListModal(false)}
        />
      )}
    </>
  );
};

export default PropertyNameList;
